export class Loanapprovallevel {

    Id : Number ;
    LoanTypeId: Number ;
    LoanCategoryId: Number ;
    LoanSchemeId: Number ;
    ApprovalLevelId: Number ;
    MinValue: Number ;
    MaxValue: Number ;
    RoleId: Number ;
    ApprovalEmployeeId: Number ;
    CompanyId: Number ;
    EmployeeBranchId: Number ;
    EmployeeId: Number ;
    SaasId: Number ;
    CreatedDate: Number ;
    ModifiedDate: Number ;
    IsActive: Number ;
    Flag: Number ;
}
